import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    currentList: []
  },
  getters: {},
  mutations: {
    setCurrentList (state, currentList) {
      state.currentList = currentList
    }
  },
  actions: {
    async storeInspectionTypeList ({commit}) {
      commit('setCurrentList', await api._getInspectionTypes())
    },
    getInspectionTypeListById ({state}, projectId) {
      return api._getInspectionTypes(projectId)
    },
    getInspectionType ({commit}, _id) {
      return api._getInspectionType(_id)
    },
    async delete ({commit, dispatch, state}, inspectionTypeId) {
      await api._deleteInspectionType(inspectionTypeId)
      await dispatch('storeInspectionTypeList')
    },
    async add ({rootState, dispatch}, inspectionType) {
      const template = inspectionType.template
      delete inspectionType.template

      const _id = await api._addInspectionType({
        ...inspectionType,
        project: rootState.project.current._id
      })

      await dispatch('uploadTemplate', {_id: _id, file: template})
    },
    async update ({dispatch}, inspectionType) {
      const template = inspectionType.template instanceof File ? inspectionType.template : null

      delete inspectionType.template

      await api._updateInspectionType(inspectionType)

      if (template) await dispatch('uploadTemplate', {_id: inspectionType._id, file: template})
    },
    async copy ({dispatch}, _id) {
      await api._copyInspectionType(_id)
    },
    async uploadTemplate ({state}, {_id, file}) {
      const {location} = await api._addInspectionTypeTemplateMeta(_id, {name: file.name, extension: file.name.split('.').pop()})

      await api._addInspectionTypeTemplateContent(location, file)
    },
    async testTemplate ({rootState}, {inspectionType, template}) {
      const result = await api._testInspectionType(inspectionType, template)

      require('downloadjs')(result, `測試_${inspectionType.name}.docx`)
    },
    async importInspectionTypes ({rootState}, ids) {
      await api._importInspectionTypes(rootState.project.current._id, ids)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/_inspectionType.js